import _ from 'lodash';
import { useEffect, useState } from 'react';

const sortFn = (option = { label: '' }) => {
  return option.label.toLowerCase();
};

const useSortedOptions = (options = [], sort = false) => {
  const [listOptions, setListOptions] = useState(options);
  useEffect(() => {
    const newOptions = options?.length ? options.filter((opt) => opt.label !== 'All') : [];
    const sortedList = sort ? _.sortBy(newOptions, [sortFn]) : newOptions;
    if (newOptions.length && options.length && newOptions.length !== options.length)
      sortedList.unshift({ value: null, label: 'All' });
    setListOptions(sortedList);
  }, [options, sort]);

  return listOptions;
};

export default useSortedOptions;
